import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../context/installation';
import { AllTriggersQuery, AllTriggersQueryVariables, Trigger } from '../../../../data-access/gql-types/graphql';
import { ALL_TRIGGERS } from '../../../../data-access/queries/triggers';

export const useTriggers = () => {
  const { selectedInstallationId, skipLavvaFetch } = useInstallationContext();

  const { data, loading, refetch } = useQuery<AllTriggersQuery, AllTriggersQueryVariables>(ALL_TRIGGERS, {
    variables: { installationId: selectedInstallationId },
    fetchPolicy: 'cache-and-network',
    skip: skipLavvaFetch,
  });

  const allTriggers = useMemo(() => data?.allTriggers as Trigger[], [data?.allTriggers]);

  const refetchTriggers = () => {
    if (selectedInstallationId) {
      refetch();
    }
  };

  return {
    allTriggers: allTriggers || [],
    loading,
    refetchTriggers,
  };
};
